// Author Lin
// Date 2021-08-11 17:38:18

import * as model from "@/model/sithMes/inventory/SithMesInventoryCountModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryCount(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .buildStore()
